import styled from "styled-components";

export const ControlsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;
